// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2pO4s","colMaxWidth":"Table_colMaxWidth__2BWsW"};